import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import MembershipCustomTextContent from '../../component/MembershipCustomTextContent/MembershipCustomTextContent'
import { Helmet } from 'react-helmet'

const cardD = [
  {
    img: false,
    title: "Consultation",
    para:'A clinician reviews your needs and goals to select or design your infusion.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "Preparation",
    para:'Ingredients are compounded onsite under strict medical supervision.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "Infusion",
    para:'Relax in a lounge setting while receiving your personalized IV, usually over 45–60 minutes.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  {
    link:"/dna-clinical-testing",
    img:"/images/creatives/service-main-3.webp",
    name:"DNA Clinical Testing:",
    rank:"",
    para:'Discover how your DNA influences risks, metabolism and treatment response.'
  },
  {
    img:"/images/creatives/service-main-8.webp",
    link:"/iv-therapy-boost-shots",
    name:"IV Therapy:",
    rank:"",
    para:'Restore energy and hydration with customized vitamin and mineral infusions.'
  },
]

const listData = [
     {
        img:"/images/creatives/naturopathic-text-1.png",
        title:"Why it matters",
        para:"Naturopathic care addresses root causes, not just symptoms—supporting the body’s ability to heal and regulate itself."
    },
     {
        img:"/images/creatives/naturopathic-text-1.png",
        title:"Who it’s for",
        para:"Ideal for those managing chronic conditions, unexplained symptoms, or seeking prevention-focused alternatives to conventional treatment."
    },
     {
        img:"/images/creatives/naturopathic-text-1.png",
        title:"How it works",
        para:"Your ND performs a detailed intake, reviews labs, and creates a targeted plan involving nutrition, botanicals, supplementation, and lifestyle strategies."
    },
]

const boostCardData = [
    "Target root causes of chronic or recurring symptoms",
    "Get a comprehensive review of lifestyle, nutrition, and biomarkers",
    "Receive natural treatment options with minimal side effects",
    "Bridge conventional and alternative care in one plan",
]


function NaturopathicMedicine() {
  return (
     <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Naturopathic Doctor Toronto | Natural Path Medicine Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/naturopathic-medicine"
        />
        <meta
          name="description"
          content="Our naturopathic doctors in Toronto provide evidence-based natural medicine to support prevention, balance, and optimal long-term health. Book a consultation."
        ></meta>
      </Helmet>
         <Header/>
        <HomeHero
            heading='Naturopathic Medicine'
            content='Personalized, holistic care grounded in natural therapies and clinical science.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/naturohero-image.png"}
            bgImage={"/images/creatives/boost-shoot-bg.png"}
            btnCalnedly={true}
            calendlyType={12}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="A personalized approach"
            para="Our Naturopathic Doctors blend evidence-based natural medicine with advanced diagnostics to help you optimize health, prevent disease, and restore balance. With a strong foundation in nutrition, lifestyle, and functional medicine, this service is ideal for individuals seeking an integrative approach to long-term wellness."
            bgImg="/images/creatives/service-main-9.webp"
          />

          <MembershipCustomTextContent
            listData={listData}
            shiftRow={true}
            nonSwitchingImg={true}
          />
        </div>

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>

        <BoostCard/>

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph="Pair naturopathic care with data-driven tools and allied services for a deeper impact."
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"contain",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
        </div>
    </div>
  )
}

export default NaturopathicMedicine